import { render, staticRenderFns } from "./BlackSoftwareTable.vue?vue&type=template&id=195c4c36"
import script from "./BlackSoftwareTable.vue?vue&type=script&lang=js"
export * from "./BlackSoftwareTable.vue?vue&type=script&lang=js"
import style0 from "./BlackSoftwareTable.vue?vue&type=style&index=0&id=195c4c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports